import React, { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import VehicleDetailContent from "./VehicleDetailContent";
import { normalizeVehicle } from "./normalizeVehicle";

export default function VehicleDetailPanel({ vehicleId }) {
    const [v, setV] = useState(null);

    // ✅ hooks FIRST
    const basePath = useMemo(
        () => (vehicleId ? ["vehicles", vehicleId] : null),
        [vehicleId]
    );
    const bookmarkKey = vehicleId ? `vehicles:${vehicleId}` : null;

    useEffect(() => {
        if (!vehicleId) return;

        return onSnapshot(doc(db, "vehicles", vehicleId), (snap) => {
            if (!snap.exists()) {
                setV(null);
                return;
            }
            setV({ id: snap.id, ...normalizeVehicle(snap.data()) });
        });
    }, [vehicleId]);

    // ✅ early returns AFTER hooks
    if (!vehicleId) {
        return <div style={{ padding: 16 }}>Select a vehicle</div>;
    }

    if (!v) {
        return <div style={{ padding: 16 }}>Loading…</div>;
    }

    return (
        <VehicleDetailContent
            v={v}
            entityId={vehicleId}
            basePath={basePath}
            bookmarkKey={bookmarkKey}
            onReactionSelect={() => { }}
        />
    );
}
